import styled from "styled-components";

export const MenuContainer = styled.div`
  display: flex;
  width: 80%;
  height: auto;

  background-color: #000;
  border-radius: 0.4rem;
`;
